import { render, staticRenderFns } from "./Immidiatetakeoff.vue?vue&type=template&id=15b84958&scoped=true&"
import script from "./Immidiatetakeoff.vue?vue&type=script&lang=js&"
export * from "./Immidiatetakeoff.vue?vue&type=script&lang=js&"
import style0 from "./Immidiatetakeoff.vue?vue&type=style&index=0&id=15b84958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b84958",
  null
  
)

export default component.exports